(function () {
	'use strict';

	angular
		.module('expo-cupom-digital')
		.controller('ForgotPasswordController', ForgotPasswordController)

	/** @ngInject */
	function ForgotPasswordController($q, $state, UserService, HelperService, NotifyService, sweetAlert) {
		const vm = this;

		vm.submitForgotPasswordForm = () => {
			var loginData = angular.copy(vm.loginForm);

			if (!loginData || !loginData.email) {
				NotifyService.error("Erro!", "Informe seu E-mail para continuar!");
				return
			}

			HelperService.startLoading(".content-body", "Verificando seus dados");

			UserService
				.verifyRegister(loginData)
				.then(success => {
					if (success.success.type == 'success') {
						HelperService.stopLoading(".content-body");
						NotifyService.error("Erro!", "Este e-mail não está cadastrado!");
					}
				})
				.catch(error => {
					if (error.data.errors.message == "E-mail já cadastrado.")
						vm.showUpdatePassword = true;
					else {
						vm.showUpdatePassword = false;
						HelperService.stopLoading(".content-body");
						HelperService.errorCallback(error);
					}
				})
		};

		vm.submitUpdatePasswordForm = () => {
			let userPwd = angular.copy(vm.passwordForm);

			let params = {
				password: Encrypt.Hash(userPwd.password).toString(),
				email: vm.loginForm.email
			}

			HelperService.startLoading(".content-body", "Atualizando sua senha");

			UserService
				.putPassword(params)
				.then(success => {
					HelperService.stopLoading(".register")

					if (success.errors) {
						HelperService.errorCallback(success);
						return
					}

					let config = {
						type: 'success',
						title: 'Sucesso!',
						text: 'Sua senha foi atualizada com sucesso!',
						confirmButtonText: 'Ir para o login',
						showCancelButton: false,
						allowOutsideClick: false,
						allowEscapeKey: false
					};

					sweetAlert
						.swal(config).then(() => {
							$state.go("app.login");
						});
				}, error => {
					HelperService.stopLoading(".register")
					HelperService.errorCallback(error)
				})
		}

		vm.showHidePwd = element => HelperService.showHidePwd(element);

		init();

		function init() {
			vm.showUpdatePassword = false;
		}

	}
}());